import { GzBasicTableWebComponent } from './component/GzBasicTableWebComponent';
import { WEB_COMPONENT_GZ_BASIC_TABLE } from '../../webcomponents.constants';

export { GzBasicTableWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_BASIC_TABLE, GzBasicTableWebComponent);
